var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded),expression:"expanded"}]},[_c('td',{staticClass:"Table__cell--table-expansion",attrs:{"colspan":_vm.colspan}},[(_vm.data)?_c('responsive-table',{attrs:{"columns":_vm.data.columns,"columnFormats":_vm.data.columnFormats,"rows":_vm.data.rows,"limit-rows":false}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }